export default __webpack_public_path__ + "d12bf5dcceb3fd3d6b404b62372ff281.png";